export default __webpack_public_path__ + "d9.png";